import getMailListViewState from 'mini-mail-list-store/lib/utils/getMailListViewState';
import MailListViewState from 'mini-mail-list-store/lib/store/schema/MailListViewState';
import React from 'react';
import strings from 'owa-strings/owa-mini-strings';
import { getMailCampaignObjects } from '../util/miniMailCampaignObjects';
import { observer } from 'mobx-react';

interface CalendarNudgeCampaignProps {
    calendarIconRef: React.RefObject<any>;
}

export const CalendarNudgeCampaign = observer((props: CalendarNudgeCampaignProps) => {
    const { calendarIconRef } = props;
    const listViewState = getMailListViewState();
    const showCampaign = listViewState in [MailListViewState.Empty, MailListViewState.Loaded];
    const { mailCalendarNudgeCampaign, mailCalendarNudgeJourney } = getMailCampaignObjects();

    return (
        showCampaign && (
            <mailCalendarNudgeCampaign.unit
                campaignViewTypeProps={{
                    content: strings.calendarNudgeTooltip,
                    placement: 'top',
                    placementRef: calendarIconRef,
                }}
                journey={mailCalendarNudgeJourney}
            />
        )
    );
});
